import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { WeekPlan } from '@/api/types'
import { Button } from '@/components/Button'
import { groupBy } from '@/utils'
import { DAYS_OF_WEEK } from '../constants'
import { sortByMeals } from '../utils'
import WeekPlanNutrition from './WeekPlanNutrition'
import WeekPlanRow from './WeekPlanRow'
import { GetReplacementsFn } from './CreateMealPlan'

type Props = {
  weekPlan: WeekPlan
  mainUserId: number
  getReplacements: GetReplacementsFn
  replacedMealIds: Record<string, boolean>
}

export default function WeekMealPlan({
  weekPlan,
  mainUserId,
  getReplacements,
  replacedMealIds,
}: Props) {
  const { t } = useTranslation()

  const groupedPlans = useMemo(
    () => groupBy(sortByMeals(weekPlan.mealPlans), 'mealOfDay'),
    [weekPlan.mealPlans],
  )

  return (
    <>
      <div className="WeekMealPlan-header panel-xs ">
        {DAYS_OF_WEEK.map((day) => (
          <div key={day} id={day} style={{ flex: 1 }}>
            {t(`profile.dayOfWeek.${day}`)}
          </div>
        ))}
      </div>

      <div className="WeekMealPlan-panel panel-xs">
        <div className="WeekPlanRow-stack">
          {Object.keys(groupedPlans).map((mealOfDay) => {
            return (
              <WeekPlanRow
                key={mealOfDay}
                mainUserId={mainUserId}
                mealOfDay={mealOfDay}
                days={DAYS_OF_WEEK.map(
                  (dow) => groupedPlans[mealOfDay].find((mp) => mp.dayOfWeek === dow) || null,
                )}
                getReplacements={getReplacements}
                replacedMealIds={replacedMealIds}
              />
            )
          })}
        </div>
      </div>

      <WeekPlanNutrition mealPlans={weekPlan.mealPlans} mainUserId={mainUserId} />
    </>
  )
}
